// extracted by mini-css-extract-plugin
export default {"title":"styles_title__HnWt6","columnContainer":"styles_columnContainer__GgOp4","tableRowContainer":"styles_tableRowContainer__7KDPe","icon":"styles_icon__3FjKl"};